import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './ui/SectionHeading';
import { Brain, Scale, Activity, AlertTriangle, FileQuestion, DollarSign, CloudOff } from 'lucide-react';
const painPoints = [{
  icon: Brain,
  title: 'Pacientes estancados',
  desc: 'Sesiones repetitivas donde el paciente entiende su problema mentalmente pero no logra cambiar la emoción ni sanar el cuerpo.'
}, {
  icon: Scale,
  title: 'Miedo al juicio académico',
  desc: 'Querés incorporar herramientas espirituales o sistémicas, pero te da miedo perder el rigor científico o ser juzgado por tus colegas.'
}, {
  icon: Activity,
  title: 'Síntomas físicos que no ceden',
  desc: 'Tu paciente arrastra dolores crónicos, alergias o contracturas que no responden a la psicoterapia verbal clásica.'
}, {
  icon: AlertTriangle,
  title: 'Frustración en consulta',
  desc: 'No sabés cómo transicionar de forma fluida y ética entre la psicología tradicional y las terapias alternativas sin confundir al consultante.'
}, {
  icon: FileQuestion,
  title: 'Herramientas sueltas de internet',
  desc: 'Tenés apuntes de constelaciones, nociones de biodecodificación y cursos de registros akáshicos, pero carecés de un método unificado de diagnóstico.'
}, {
  icon: DollarSign,
  title: 'Falta de estructura de cobro',
  desc: 'Sentís que regalás tu trabajo o cobrás sesiones sueltas y baratas, lo que te obliga a saturarte de pacientes para llegar a fin de mes.'
}, {
  icon: CloudOff,
  title: 'Bypass Espiritual',
  desc: "Pacientes que quieren 'resolver todo en el plano del alma' pero evaden el trabajo psicológico real y el enraizamiento en el día a día."
}];
export const PainPoints = () => {
  return <section className="py-24 bg-cream-100 relative border-y border-gold-500/10" data-id="element-209">
      <div className="absolute inset-0 bg-noise opacity-10 pointer-events-none" data-id="element-210"></div>
      <div className="container mx-auto px-6 relative z-10" data-id="element-211">
        <SectionHeading title="¿TE PASA ESTO EN TU CONSULTORIO?" subtitle="Si sos psicólogo o terapeuta en la actualidad, esto te va a sonar muy familiar:" data-id="element-212" />

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto mb-16" data-id="element-213">
          {painPoints.map((point, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="bg-cream p-6 rounded-sm border border-navy/5 hover:border-gold-500/30 transition-colors group" data-id="element-214">
              <div className="w-12 h-12 bg-navy/5 rounded-full flex items-center justify-center mb-4 group-hover:bg-gold-500/10 transition-colors" data-id="element-215">
                <point.icon className="w-6 h-6 text-navy group-hover:text-gold-600 transition-colors" data-id="element-216" />
              </div>
              <h3 className="font-serif font-bold text-xl mb-2 text-navy" data-id="element-217">
                {point.title}
              </h3>
              <p className="text-navy/70 text-sm leading-relaxed" data-id="element-218">
                {point.desc}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center max-w-3xl mx-auto bg-navy p-8 rounded-sm shadow-xl" data-id="element-219">
          <h3 className="text-2xl md:text-3xl font-serif text-cream italic" data-id="element-220">
            ¿Cuántos meses más vas a atender improvisando tus intervenciones?
          </h3>
        </motion.div>
      </div>
    </section>;
};